module.exports = __webpack_public_path__ + "img/posisi.fcc529a0.png";